// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 161) return "static/chunks/161-61f9db08753e9d17.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1767":"d802771f63489659","2741":"724032bde111d079","4797":"1fd0f12335ab01e1","5557":"849e043e189abf34","9651":"7137cc383942b1db"}[chunkId] + ".js";
};